/**
 * @param {('ConnectWallet'|'JoinDiscord'|'MintStart'|'MintPurchase'|'ABCsWebinar')} eventName
 * @param {Object.<string, string | number>} [metadata]
 */
export default function dispatchPixelEvent(eventName, metadata) {
  window.fbq('track', eventName, metadata);
}
